<body>

    <div class="login-box">
        <h2>Sign in</h2>
        <p>Sign in with your Employee Email and password</p>
        <form (ngSubmit)="onSubmit()">
            <div class="form-group">
                <label>Employee Email *</label>
                <div class="input-wrap employee">
                    <input type="email" [(ngModel)]="email" name="email" required />
                </div>
            </div>

            <div class="form-group">
                <label>Password *</label>
                <div class="input-wrap password">
                    <input type="password" [(ngModel)]="password" name="password" required />
                </div>
            </div>

            <button class="login-btn" type="submit">LOGIN</button>
        </form>

    </div>
</body>





<!-- <form (ngSubmit)="onSubmit()" #loginForm="ngForm">
    <div>
      <label for="email">Email:</label>
      <input
        type="email"
        id="email"
        name="email"
        [(ngModel)]="loginData.email"
        required
      />
    </div>

    <div>
      <label for="password">Password:</label>
      <input
        type="password"
        id="password"
        name="password"
        [(ngModel)]="loginData.password"
        required
      />
    </div>

    <button type="submit" [disabled]="!loginForm.valid">Login</button>
  </form> 
</div>-->


<!-- <p>login works!</p> -->

<!-- <section class="bg-light-pink" *ngIf="!loading">

    <div class="login-page">

        <div class="left-box">
            <div class="left-box-inner">
                <img src="../assets/images/logo/login.png" alt="Image">
                <div class="profile-pic">
                     <img src="../assets/images/white-profile.png" alt="Image">
                </div>
                <h4>--</h4>
                <p>--</p>
            </div>
        </div>

        <div class="login-form-box">
            <div class="login-from-inner">
                <h2> Sign In</h2>
                <p> please enter your Credential to login</p>
                <form [formGroup]="loginForm">
                    <div class="input-box">
                        <label>Email Address</label>
                        <input type="email" placeholder="Enter your mail ID" value="" name="name" required
                            formControlName="email" />
                        <div *ngIf="(loginForm?.get('email')?.invalid) && (loginForm?.get('email')?.touched) || buttonClick">
                            <div *ngIf="loginForm?.get('email')?.errors?.required" style="color: red;">Email is required
                            </div>
                        </div>
                    </div>
                    <div class="input-box">
                        <label>Password</label>
                        <input type="password" placeholder="**********" value="" name="name" required
                            formControlName="password" />
                        <div *ngIf="(loginForm?.get('password')?.invalid) && (loginForm?.get('password')?.touched) || buttonClick">
                            <div *ngIf="loginForm?.get('password')?.errors?.required" style="color: red;">Password is required
                            </div>
                        </div>
                    </div>
                    <div class="checkbox-outer">
                        <div class="for-checkbox">
                            <input type="checkbox" id="remember" name="remember" value="rem"
                                style="margin-left: 5px;" [(ngModel)]="isRemember" [ngModelOptions]="{standalone: true}" />
                            <label for="remember" style="margin-left: 5px;"> Remember me</label>
                        </div>
                    </div>
                    <div class="login-button">
                        <input type="submit" value="Login" (click)="login()" [disabled]="!loginForm.valid" *ngIf="!requesting"/>
                        <div class="text-center" *ngIf="requesting">
                            <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                              <span class="sr-only">Loading...</span>
                        </div>
                        </div>
                    </div>

                </form>
            </div>
        </div>

    </div>

</section>

<div class="text-center" *ngIf="loading">
    <div class="spinner-border" style="width: 3rem; height: 3rem" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>

<pre *ngIf="error?.error">{{error?.error | json}}</pre> -->


<!-- <div class="login-container">
  <h2>Login</h2>
  <form (ngSubmit)="onSubmit()">
  <label>Email:</label>
  <input type="email" [(ngModel)]="email" name="email" required />

  <label>Password:</label>
  <input type="password" [(ngModel)]="password" name="password" required />

  <button type="submit">Login</button>
</form> -->